import { useRouter } from 'next/router';
import React, { FC, useMemo } from 'react';
import { generateAlgoliaConfigProps } from '~/features/productList/Algoliga.utils';
import ProductsLoader from '~/features/productList/ProductsLoader';
import { useTranslation } from '~/shared/utils/translation';
import { ModuleContainer } from '~/templates/blocks/components/ModuleContainer';
import SearchPageHero from './SearchPageHero';
import { P10SearchPage as P10SearchPageProps } from '~/lib';
import { getQueryValue } from '~/shared/utils/get-query-value';
import { GTM_LIST_ID } from '~/shared/hooks/useEvents/useGTMEvents/models';
import { usePage } from '~/templates/pages/hooks/usePage';
import { algoliaClient } from '~/services/instantsearch';
import { AlgoliaProductList } from '~/services/instantsearch/components';

export const P10SearchPage: FC<P10SearchPageProps> = ({ data }) => {
    const { productListPageSize } = usePage();
    const { query: params } = useRouter();
    const { translate } = useTranslation();

    const { serverUrl } = data?.plpResult || {};

    const searchTerm = getQueryValue(params.query) ?? '';

    const algoliaConfiguration = useMemo(
        () =>
            generateAlgoliaConfigProps({
                filter: 'search',
                filterType: 'Context Rule Name',
            }),
        [],
    );

    return (
        <AlgoliaProductList searchClient={algoliaClient}>
            <ModuleContainer spacingTop="none" fullWidth hasGutter={false}>
                <SearchPageHero
                    headline={`${translate('search.searchResultPageText')} "${searchTerm}"`}
                    belowText={translate('search.noResults')}
                />

                <ProductsLoader
                    spacingTop="none"
                    hitsPerPage={productListPageSize}
                    configuration={algoliaConfiguration}
                    listId={GTM_LIST_ID.SEARCH_RESULTS}
                    serverUrl={serverUrl}
                />
            </ModuleContainer>
        </AlgoliaProductList>
    );
};
